import { createContext, useContext } from "react"

type HeaderToolsMenuContextValue = {
  isMenuOpen: boolean
  closeMenu: () => void
  focusMenuButton: () => void
}

// Lets a tool in the mobile drawer close it and hand focus back to the menu button.
export const HeaderToolsMenuContext = createContext<HeaderToolsMenuContextValue>({
  isMenuOpen: false,
  closeMenu: () => undefined,
  focusMenuButton: () => undefined
})

export const useHeaderToolsMenu = () => useContext(HeaderToolsMenuContext)
